import { useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { useAuthSync } from '../../hooks/useAuthSync';
import { prefetchPropertyListingRoute } from '../../utils/lazyWithRetry';

export default function Layout() {
  // Sync authentication state with user store at the top level
  useAuthSync();

  const onListingLinkIntent = useCallback((e: React.PointerEvent) => {
    const el = (e.target as HTMLElement | null)?.closest?.('a[href^="/properties"]');
    if (el) prefetchPropertyListingRoute();
  }, []);

  return (
    <div className="flex flex-col min-h-screen" onPointerOver={onListingLinkIntent}>
      <Header />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}